module.exports = __webpack_public_path__ + "WealthCare Saver HSA Death Distribution Form.pdf";